"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.filter.project': 'Filter by Project',
    'knowledge.filter.project.placeholder': 'Search projects...',
    'knowledge.filter.all_projects': 'All Projects',
    'knowledge.filter.assigned_only': 'Show only assigned knowledge',
    'knowledge.filter.by_avatar': 'Filter by Avatar',
    'knowledge.filter.all_avatars': 'All Avatars',
};
